/* eslint-disable react-hooks/exhaustive-deps */
import { alpha, Avatar, Backdrop, Box, Button, CircularProgress, Fade, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import UserService from "../../../services/userService";
import { fileApiRoute } from "../../../services/networkService";


const ViewUserModal = ({ open,
    handleClose,
    userId }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const [user, setUser] = useState({});
    const [isModalLoading, setIsModalLoading] = useState(true);

    const fetchUser = async () => {
        try {
            const data = await UserService.fetchOne(userId);
            setUser(data);
            setIsModalLoading(false);
        } catch (error) {
            console.error('Error fetching user:', error);
        }
    };

    useEffect(() => {
        setIsModalLoading(true);
        if (open) {
            fetchUser();
        }
    }, [open]);


    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            aria-hidden="false"
            aria-modal="true"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isTablet ? '90%' : '40%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: isTablet ? 1 : 4,
                        height: '80vh',
                        overflowY: 'scroll'
                    }}
                >
                    {isModalLoading ? <Box sx={{ justifyContent: 'center', display: 'flex', my: 10 }} >
                        <CircularProgress color="primary" size={28} />
                    </Box>
                        : <Box>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>

                                <Typography id="transition-modal-title" variant="h6" component="h2">
                                    {t('userInfo')}
                                </Typography>
                                <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                            </Box>

                            <Typography variant="body1" sx={{ mt: 2 }}>
                                {t('name')}: <span style={{ fontWeight: 'bold' }}>{user.name}</span>
                            </Typography>

                            <Typography variant="body1" sx={{ mt: 2 }}>
                                {t('branch')}: <span style={{ fontWeight: 'bold' }}>{user.branch.name}</span>
                            </Typography>

                            <Typography variant="body1" sx={{ mt: 2 }}>
                                {t('phone')}: <span style={{ fontWeight: 'bold' }}>{user.phone}</span>
                            </Typography>

                            <Typography variant="body1" sx={{ mt: 2 }}>
                                {t('phoneTwo')}: <span style={{ fontWeight: 'bold' }}>{user.phoneTwo}</span>
                            </Typography>

                            <Typography variant="body1" sx={{ mt: 2 }}>
                                {t('type')}: <span style={{ fontWeight: 'bold' }}>{t(user.type)}</span>
                            </Typography>

                            {/* role */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                <Typography variant="body1" sx={{ mt: 1 }}>
                                    {t('role')}:
                                </Typography>
                                <Box
                                    sx={{
                                        bgcolor: alpha(
                                            user.role.superAdmin ? theme.palette.green.box : theme.palette.purple.box, 0.2),
                                        width: 140,
                                        justifyContent: 'center',
                                        display: 'flex',
                                        py: 0.2,
                                        borderRadius: 0.8,
                                        mt: 2,
                                        mx: 1
                                    }}
                                >
                                    <Box
                                        sx={{
                                            fontWeight: 'bold',
                                            color: user.role.superAdmin ? theme.palette.green.box : theme.palette.purple.box,
                                        }}
                                    >
                                        {user.role.name}
                                    </Box>
                                </Box>
                            </Box>

                            <Typography variant="body1"
                                sx={{
                                    mt: 1.5,
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    maxHeight: '4.5em',
                                    lineHeight: '1.5em'
                                }}>
                                {t('note')}: <span style={{ fontWeight: 'bold' }}>{user.note}</span>
                            </Typography>


                            {/* status */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                <Typography variant="body1" sx={{ mt: 2 }}>
                                    {t('status')}:
                                </Typography>
                                <Box
                                    sx={{
                                        justifyContent: 'center',
                                        display: 'flex',
                                        py: 0.2,
                                        mt: 2,
                                        mx: 0.3
                                    }}
                                >
                                    <Box
                                        sx={{
                                            fontWeight: 'bold',
                                            color: user.status === 'active' ? theme.palette.green.box : theme.palette.red.box,
                                        }}
                                    >
                                        {t(user.status)}
                                    </Box>
                                </Box>
                            </Box>

                            {/* images */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                    mt: 2
                                }}>
                                <Box sx={{ width: '48%' }}>
                                    <Typography variant="body1">
                                        {t('image')}:
                                    </Typography>
                                    <Avatar
                                        variant="rounded"
                                        src={`${fileApiRoute}/${user.image}`}
                                        sx={{
                                            cursor: 'pointer',
                                            width: '100%',
                                            height: '120px',
                                            mt: 1
                                        }}
                                    />
                                </Box>

                                <Box sx={{ width: '48%' }}>
                                    <Typography variant="body1">
                                        {t('IDimage')}:
                                    </Typography>
                                    <Avatar
                                        variant="rounded"
                                        src={`${fileApiRoute}/${user.IDImage}`}
                                        sx={{
                                            cursor: 'pointer',
                                            width: '100%',
                                            height: '120px',
                                            mt: 1
                                        }}
                                    />
                                </Box>

                            </Box>

                            <Box sx={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                mt: 2
                            }}>
                                {/* close */}
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    sx={{ textTransform: 'none', width: 140, height: 40 }}
                                    onClick={handleClose}
                                >
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p>{t('close')}</p>
                                        <CloseOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                    </Box>
                                </Button>

                                <Box width={20}></Box>

                            </Box>
                        </Box>
                    }
                </Box>
            </Fade>
        </Modal>
    );
}

export default ViewUserModal;
